import { FieldType } from '@pmp/api';

export const NOTES_LIST_NAMES: FieldType[] = [FieldType.NOTE_CATEGORY];